export const Marquee = ({ items = [], reverse = false, className = "" }) => {
  const doubled = [...items, ...items];
  return (
    <div className={`overflow-hidden ${className}`} data-testid="editorial-marquee">
      <div className={`marquee-track ${reverse ? "animate-marquee-rev" : "animate-marquee"}`}>
        {doubled.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display font-bold text-4xl sm:text-6xl lg:text-7xl text-white/90 px-6">
              {item}
            </span>
            <span className="text-amber text-3xl sm:text-5xl px-2">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};
